export const export_report = {
  export_btn: 'Laporan ekspor',
  xls: 'xls',
  csv: 'csv',
  export_modal: 'Ekspor',
  export_records: 'Catatan ekspor'
};
